[
  {
    "codigo": 11,
    "sigla": "RO",
    "nome": "Rondônia",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 12,
    "sigla": "AC",
    "nome": "Acre",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 13,
    "sigla": "AM",
    "nome": "Amazonas",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 14,
    "sigla": "RR",
    "nome": "Roraima",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 15,
    "sigla": "PA",
    "nome": "Pará",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 16,
    "sigla": "AP",
    "nome": "Amapá",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 17,
    "sigla": "TO",
    "nome": "Tocantins",
    "regiao": {
      "id": 1,
      "nome": "Norte"
    }
  },
  {
    "codigo": 21,
    "sigla": "MA",
    "nome": "Maranhão",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 22,
    "sigla": "PI",
    "nome": "Piauí",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 23,
    "sigla": "CE",
    "nome": "Ceará",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 24,
    "sigla": "RN",
    "nome": "Rio Grande do Norte",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 25,
    "sigla": "PB",
    "nome": "Paraíba",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 26,
    "sigla": "PE",
    "nome": "Pernambuco",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 27,
    "sigla": "AL",
    "nome": "Alagoas",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 28,
    "sigla": "SE",
    "nome": "Sergipe",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 29,
    "sigla": "BA",
    "nome": "Bahia",
    "regiao": {
      "id": 2,
      "nome": "Nordeste"
    }
  },
  {
    "codigo": 31,
    "sigla": "MG",
    "nome": "Minas Gerais",
    "regiao": {
      "id": 3,
      "nome": "Sudeste"
    }
  },
  {
    "codigo": 32,
    "sigla": "ES",
    "nome": "Espírito Santo",
    "regiao": {
      "id": 3,
      "nome": "Sudeste"
    }
  },
  {
    "codigo": 33,
    "sigla": "RJ",
    "nome": "Rio de Janeiro",
    "regiao": {
      "id": 3,
      "nome": "Sudeste"
    }
  },
  {
    "codigo": 35,
    "sigla": "SP",
    "nome": "São Paulo",
    "regiao": {
      "id": 3,
      "nome": "Sudeste"
    }
  },
  {
    "codigo": 41,
    "sigla": "PR",
    "nome": "Paraná",
    "regiao": {
      "id": 4,
      "nome": "Sul"
    }
  },
  {
    "codigo": 42,
    "sigla": "SC",
    "nome": "Santa Catarina",
    "regiao": {
      "id": 4,
      "nome": "Sul"
    }
  },
  {
    "codigo": 43,
    "sigla": "RS",
    "nome": "Rio Grande do Sul",
    "regiao": {
      "id": 4,
      "nome": "Sul"
    }
  },
  {
    "codigo": 50,
    "sigla": "MS",
    "nome": "Mato Grosso do Sul",
    "regiao": {
      "id": 5,
      "nome": "Centro-Oeste"
    }
  },
  {
    "codigo": 51,
    "sigla": "MT",
    "nome": "Mato Grosso",
    "regiao": {
      "id": 5,
      "nome": "Centro-Oeste"
    }
  },
  {
    "codigo": 52,
    "sigla": "GO",
    "nome": "Goiás",
    "regiao": {
      "id": 5,
      "nome": "Centro-Oeste"
    }
  },
  {
    "codigo": 53,
    "sigla": "DF",
    "nome": "Distrito Federal",
    "regiao": {
      "id": 5,
      "nome": "Centro-Oeste"
    }
  }
]
